'use client'
import { Typography, MediaImageStandard } from 'components/Contentful'
import { BLOCKS } from '@contentful/rich-text-types'
import { Grid } from '@achieve/ascend'
import { formatPublishDate } from 'utils/conversions'
import { useContentfulInspectorMode } from '@contentful/live-preview/react'

function AuthorTag({ authorName, authorPhoto, publishDate, entryId }) {
  const inspectorProps = useContentfulInspectorMode()
  const dateString = formatPublishDate(publishDate)
  return (
    <Grid container className={'min-w-[250px]'} data-testid="press-article-author-tag-grid">
      {authorPhoto && (
        <div
          className={'pr-4'}
          {...inspectorProps({
            entryId,
            fieldId: 'authorPhoto',
          })}
        >
          <MediaImageStandard
            alt={authorName}
            className={'rounded-[60px]'}
            content={authorPhoto}
            layout="fixed"
            height={60}
            width={60}
            data-testid="press-article-author-headshot"
          />
        </div>
      )}
      <Grid
        container
        className={'w-auto flex-col justify-center items-start'}
        data-testid="press-article-author-tag-text-container"
      >
        {authorName && (
          <Typography
            content={`by ${authorName}`}
            variantOverride={{ [BLOCKS.PARAGRAPH]: 'bodySm' }}
            className={'text-neutral-900 leading-[170%]'}
            data-testid="press-article-author-name-text"
            {...inspectorProps({
              entryId,
              fieldId: 'authorName',
            })}
          />
        )}

        {publishDate && (
          <Typography
            content={`${dateString}`}
            variantOverride={{ [BLOCKS.PARAGRAPH]: 'bodySm' }}
            className={'text-neutral-900 leading-[170%]'}
            data-testid="press-article-publish-date-text"
            {...inspectorProps({
              entryId,
              fieldId: 'publishDate',
            })}
          />
        )}
      </Grid>
    </Grid>
  )
}

export { AuthorTag }
